import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircleMore, X } from 'lucide-react';
import { useCreateFeedback } from '@/lib/api/hooks/useFeedback.ts';
import { Spin, message } from 'antd';
// import { useAuth } from '@/context/AuthContext';
export default function FeedbackButton() {
  // const { userEmail } = useAuth();
  const [hovered, setHovered] = useState(false);
  const [open, setOpen] = useState(false);
  const [showFeedback, setShowFeedback] = useState(true);
  const [feedback, setFeedback] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { mutateAsync: createFeedback } = useCreateFeedback();
  useEffect(() => {
    const show = sessionStorage.getItem('showFeedback');
    setShowFeedback(show === 'false' ? false : true);
  }, []);
  const handleFeedbackClose = () => {
    setShowFeedback(false);
    sessionStorage.setItem('showFeedback', 'false');
  };
  // const feedbackEmail = import.meta.env.FEEDBACK_EMAIL || 'connect@sellco.ai';
  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (feedback === '') {
      message.error('Please enter your feedback');
      return;
    }
    try {
      setIsSubmitting(true);
      await createFeedback({ feedback });
      setIsSubmitting(false);
      setFeedback('');
      setOpen(false);
      setShowFeedback(false);
    } catch (error) {
      setIsSubmitting(false);
      console.error('Error submitting feedback:', error);
    }
  };

  return (
    <>
      {/* Floating Button */}
      {showFeedback && (
        <motion.div
          className="fixed bottom-10 z-20 right-5 flex items-center bg-amber-500 text-white rounded-full shadow-lg cursor-pointer"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          whileHover={{ scale: 1.05 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
        >
          <div
            className={
              'absolute right-0 p-0.5 -top-2 rounded-full bg-red-600 text-white cursor-pointer'
            }
            onClick={handleFeedbackClose}
          >
            <X size={15} />
          </div>
          <div className={'flex items-center'} onClick={() => setOpen(true)}>
            {/* Icon */}
            <div className="p-3">
              <MessageCircleMore />
            </div>

            {/* Expanding Text */}
            <motion.div
              initial={{ width: 0, opacity: 0 }}
              animate={{
                width: hovered ? 'auto' : 0,
                opacity: hovered ? 1 : 0,
              }}
              transition={{ duration: 0.3 }}
              className="pr-4 whitespace-nowrap"
            >
              Feedback
            </motion.div>
          </div>
        </motion.div>
      )}

      {/* Feedback Form Modal */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-30"
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-lg"
            >
              {/* Header */}
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-lg font-semibold text-gray-700">
                  Send Feedback
                </h2>
                <button
                  onClick={() => setOpen(false)}
                  className="text-gray-500 hover:text-gray-400 cursor-pointer"
                >
                  <X size={20} />
                </button>
              </div>

              {/* Form */}
              <form onSubmit={onSubmit} className="flex flex-col gap-4">
                <textarea
                  placeholder="Write your feedback..."
                  className="w-full p-3 border border-amber-400 rounded-lg focus:ring-2 focus:ring-amber-400 outline-none"
                  rows={4}
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                />
                <button
                
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-amber-500 !text-white py-2 rounded-lg hover:bg-amber-600 transition cursor-pointer"
                >
                  {isSubmitting ? <Spin size={'small'} /> : 'Submit'}
                </button>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
